import type { TrainingLessonSpecific } from './trainingLessonUi';

export const deacon2ServiceEn: TrainingLessonSpecific = {
  intro:
    'The office of deacon is exercised chiefly through service. In this lesson you will learn to serve with initiative, humility, and teamwork—without seeking recognition.',
  objectives: [
    'Understand that service is the main way to exercise the office of deacon.',
    'Learn to serve without drawing attention or expecting praise.',
    'Develop initiative: see needs and act with permission and order.',
    'Practice respect, reverence, and teamwork with other priesthood holders.',
    'Create a simple weekly plan of service (at home + at church).',
  ],
  briefHeading: 'Service as a deacon in brief',
  briefBody:
    'A reliable deacon sees needs and acts with permission and order. He serves quietly, works as a team with other priesthood holders, and plans weekly service at home and at church. The office is about bearing others’ burdens, not showing off.',
  scriptures: [
    {
      ref: 'Mosiah 2:17',
      text: '…when ye are in the service of your fellow beings ye are only in the service of your God.',
    },
    {
      ref: 'D&C 58:26–28',
      text: '…men should be anxiously engaged in a good cause…',
    },
    {
      ref: 'Matthew 20:26–28',
      text: '…whosoever will be great among you, let him be your minister…',
    },
    { ref: 'Alma 37:6–7', text: '…by small and simple things are great things brought to pass…' },
    { ref: 'D&C 84:106', text: '…succor the weak, lift up the hands which hang down…' },
  ],
  didYouKnow: [
    '“Quiet” service is spiritual training: it teaches you to act from love, not applause.',
    'Initiative is not chaos: a deacon with initiative asks, coordinates, and acts humbly.',
  ],
  practiceItems: [
    'List three needs you see at home or at church',
    'Pick one need and make a simple plan: what, when, and whom to coordinate with',
    'Ask a leader (parent/bishopric/quorum) how you can help with something specific',
    'Serve without announcing it (no post or comment—just do it)',
    'Practice teamwork: help another deacon with his part without bossing him',
    'At day’s end, write one line: “Today I served by ____ and felt ____.”',
  ],
  reflectionQuestions: [
    'What stops me from serving more: laziness, embarrassment, distraction, or pride?',
    'Whose life would be easier if I served better this week?',
    'How can I show reverence while serving (unhurried, not careless)?',
  ],
  actionText:
    'Fixed weekly service: choose one action you will do every week (e.g., tidy up, help an older member, prep Sunday items, help parents without being asked).',
};
